const _temp0 = require("./components/accordion.js");
const _temp1 = require("./components/countdown-event.js");
const _temp2 = require("./components/footer.js");
const _temp3 = require("./components/logo-carousel.js");
const _temp4 = require("./components/mega-menu.js");
const _temp5 = require("./components/nav.js");
const _temp6 = require("./components/posts-carousel.js");
const _temp7 = require("./components/query-bar.js");
const _temp8 = require("./components/tooltip.js");
const _temp9 = require("./components/video-tabs.js");
module.exports = {
  "accordion.js": _temp0,
  "countdown-event.js": _temp1,
  "footer.js": _temp2,
  "logo-carousel.js": _temp3,
  "mega-menu.js": _temp4,
  "nav.js": _temp5,
  "posts-carousel.js": _temp6,
  "query-bar.js": _temp7,
  "tooltip.js": _temp8,
  "video-tabs.js": _temp9
}